export default "__VITE_ASSET__BVu996qs__"